$(() => {
  $('.rum-awards__carousel').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 750,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          speed: 350,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
});
